import { useState, useEffect } from 'react'
import api, { IBookingImport } from '@api'

export default function useActiveImport() {
  const [loading, setLoading] = useState(true)
  const [activeImport, setActiveImport] = useState<IBookingImport | null>(null)

  useEffect(() => {
    api.booking.import.active().then((activeImport) => {
      setLoading(false)
      setActiveImport(activeImport || null)
    })
  }, [])

  return { loading, activeImport }
}
